import { ITransaction } from '../../../interface/transaction';
import { useEffect } from 'react';
import NoData from '../noData';
import { DocumentTextEmpty } from '../../icons';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import { Radio, RadioGroup, Spin, Text } from '../../Ant';
import SkeletonOptionList from '../../common/skeleton/skeletonOptionList';
import SearchInputWithFilters from '../SearchInputWithFilters';
import CollapsibleListLayout from '../../collapsibleListLayout/collapsibleListLayout';

const MatterTransaction = ({
  transactions,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  isLoading,
  isFetching,
  onSelect,
  searchValue,
  onSearch = () => {},
  onRefresh,
}: {
  transactions: ITransaction[];
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  isLoading: boolean;
  isFetching: boolean;
  onSelect: (value: string) => void;
  searchValue?: string;
  onSearch?: (value: string) => void;
  onRefresh?: () => void | Promise<unknown>;
}) => {
  const { t } = useTranslation();
  const { ref, inView } = useInView({
    threshold: 0.5, // Trigger when 50% of the target is visible
  });

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage && transactions?.length > 0) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage]);
  const renderLoader = () => {
    if (isFetching) {
      return <Spin data-testid="small-indicator" size="small" />;
    }
    return null;
  };
  return (
    <CollapsibleListLayout
      testId="matter-transaction-listing"
      header={
        <SearchInputWithFilters
          searchTitle={t('transaction:searchSubjects')}
          searchValue={searchValue}
          handleSearch={onSearch}
          handleRefresh={onRefresh}
        />
      }
    >
      {transactions && transactions.length > 0 && (
        <RadioGroup
          data-testid="matter-transaction"
          className="d-flex fd-column gap-10 suggetions-list"
          onChange={(e) => {
            onSelect(e.target.value);
          }}
        >
          {transactions.map((transaction) => (
            <Radio
              data-testid={`radio-button-${transaction?.subject}`}
              key={transaction.id}
              value={transaction.subject}
            >
              <Text $fontsize="12px" $color="subtitle" $lineheight="20px">
                {transaction.subject}
              </Text>
            </Radio>
          ))}
        </RadioGroup>
      )}
      {hasNextPage && <div ref={ref} className="loading-indicator" />}
      {(!transactions || (Object.entries(transactions).length === 0 && !isLoading)) && (
        <div className="h-full d-flex justify-center items-center">
          <NoData
            header={t('transaction:noTransactions')}
            subHeader={t('common:tryChangingSearchCriteria')}
            icon={<DocumentTextEmpty />}
          />
        </div>
      )}
      {isLoading ? <SkeletonOptionList withControl={false} /> : renderLoader()}
    </CollapsibleListLayout>
  );
};

export default MatterTransaction;
